import React, { useEffect, useState } from "react";

function formatTime(totalSeconds) {
  if (totalSeconds === null || totalSeconds === undefined) {
    return "—";
  }

  const seconds = Math.max(0, totalSeconds);

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return [
    hours.toString().padStart(2, "0"),
    minutes.toString().padStart(2, "0"),
    secs.toString().padStart(2, "0"),
  ].join(":");
}

export default function TATTimer({
  tatDeadline,
  tatStatus,
  tatRemainingSeconds,
}) {
  const [remainingSeconds, setRemainingSeconds] = useState(
    tatRemainingSeconds
  );

  useEffect(() => {
    // Completed cases don't need a countdown
    if (tatStatus === "completed") {
      setRemainingSeconds(null);
      return;
    }

    if (!tatDeadline) {
      setRemainingSeconds(null);
      return;
    }

    const deadline = new Date(tatDeadline).getTime();

    const updateTimer = () => {
      const now = Date.now();

      const remaining = Math.floor((deadline - now) / 1000);

      setRemainingSeconds(Math.max(0, remaining));
    };

    // Update immediately
    updateTimer();

    // Update every second
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [tatDeadline, tatStatus]);

  // ----------------------------------------------------
  // COMPLETED
  // ----------------------------------------------------

  if (tatStatus === "completed") {
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
        <span className="w-2 h-2 rounded-full bg-green-600"></span>
        Completed
      </span>
    );
  }

  // ----------------------------------------------------
  // NO TAT
  // ----------------------------------------------------

  if (!tatDeadline) {
    return (
      <span className="text-xs text-[#9CA3AF]">
        —
      </span>
    );
  }

  // ----------------------------------------------------
  // BREACHED
  // ----------------------------------------------------

  if (remainingSeconds <= 0) {
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold bg-red-100 text-red-700 border border-red-200">
        <span className="w-2 h-2 rounded-full bg-red-600 animate-pulse"></span>
        TAT Breached
      </span>
    );
  }

  // ----------------------------------------------------
  // WARNING - 15 MINUTES
  // ----------------------------------------------------

  if (remainingSeconds <= 15 * 60) {
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-bold bg-amber-100 text-amber-700 border border-amber-200 font-mono">
        <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse"></span>
        {formatTime(remainingSeconds)}
      </span>
    );
  }

  // ----------------------------------------------------
  // RUNNING
  // ----------------------------------------------------

  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-semibold bg-green-50 text-green-700 border border-green-200 font-mono">
      <span className="w-2 h-2 rounded-full bg-green-500"></span>
      {formatTime(remainingSeconds)}
    </span>
  );
}